function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#46B385"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.636 15.036C20.3239 13.3482 22.6131 12.4 25 12.4C26.1819 12.4 27.3522 12.6328 28.4442 13.0851C29.5361 13.5374 30.5282 14.2003 31.364 15.036C32.1997 15.8718 32.8626 16.8639 33.3149 17.9558C33.7672 19.0478 34 20.2181 34 21.4C34 26.035 26.566 36.106 25.72 37.24C25.6362 37.3518 25.5275 37.4425 25.4025 37.505C25.2775 37.5675 25.1397 37.6 25 37.6C24.8603 37.6 24.7225 37.5675 24.5975 37.505C24.4725 37.4425 24.3638 37.3518 24.28 37.24C23.434 36.106 16 26.035 16 21.4C16 19.013 16.9482 16.7239 18.636 15.036ZM17.8 21.4C17.8 24.487 22.48 31.651 25 35.17C27.52 31.651 32.2 24.487 32.2 21.4C32.2 19.4904 31.4414 17.6591 30.0912 16.3088C28.7409 14.9586 26.9096 14.2 25 14.2C23.0904 14.2 21.2591 14.9586 19.9088 16.3088C18.5586 17.6591 17.8 19.4904 17.8 21.4ZM22.4999 17.6584C23.24 17.1639 24.11 16.9 25 16.9C26.1935 16.9 27.3381 17.3741 28.182 18.218C29.0259 19.062 29.5 20.2065 29.5 21.4C29.5 22.29 29.2361 23.1601 28.7416 23.9001C28.2472 24.6401 27.5444 25.2169 26.7221 25.5575C25.8998 25.8981 24.995 25.9872 24.1221 25.8136C23.2492 25.6399 22.4474 25.2113 21.818 24.582C21.1887 23.9527 20.7601 23.1508 20.5865 22.2779C20.4128 21.405 20.502 20.5002 20.8425 19.6779C21.1831 18.8557 21.7599 18.1529 22.4999 17.6584ZM23.5 23.645C23.944 23.9417 24.466 24.1 25 24.1C25.7161 24.1 26.4029 23.8156 26.9092 23.3092C27.4155 22.8029 27.7 22.1161 27.7 21.4C27.7 20.866 27.5417 20.344 27.245 19.9C26.9483 19.456 26.5266 19.1099 26.0333 18.9055C25.5399 18.7012 24.997 18.6477 24.4733 18.7519C23.9495 18.8561 23.4684 19.1132 23.0908 19.4908C22.7132 19.8684 22.4561 20.3495 22.3519 20.8733C22.2477 21.397 22.3012 21.9399 22.5055 22.4333C22.7099 22.9266 23.056 23.3483 23.5 23.645Z",
  fill: "white"
});

var SvgGeneralLocation = function SvgGeneralLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGeneralLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/general_location.c2721cb2.svg";
export { ForwardRef as ReactComponent };